// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNavigationArrowCw = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="m13.244 2.257 3.81 4.727a.5.5 0 0 1-.076.703l-4.747 3.827a.5.5 0 0 1-.685-.054l-.676-.75a.5.5 0 0 1 .058-.724l2.438-1.957.005-.052a6.108 6.108 0 1 0 4.719 6.428.534.534 0 0 1 .518-.502l.892-.003a.477.477 0 0 1 .486.498 8.006 8.006 0 0 1-1.473 4.176 8 8 0 1 1-4.939-12.489l.005-.045-1.913-2.524a.5.5 0 0 1 .082-.695l.793-.64a.5.5 0 0 1 .703.076z"
    />
  </svg>
);
export default SvgNavigationArrowCw;
